"use strict";

/**
 * @param {PluginOptions} opts Plugin options
 * @param {Node} node
 * @return {Boolean} true if the node is a UL or OL
 */
function isList(opts, node) {
  return opts.types.includes(node.type);
}

module.exports = isList;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-edit-list/dist/isList.js
// module id = 108
// module chunks = 0